import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

const TrashButton = ({ onDelete }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleConfirmDelete = () => {
    onDelete();
    handleClose();
  };

  return (
    <>
      <IconButton color="error" onClick={handleOpen} size="small" >
        <DeleteIcon sx={{ fontSize: '18px' }}/>
      </IconButton>
      
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>本当に削除しますか？</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary">キャンセル</Button>
          <Button onClick={handleConfirmDelete} color="error">削除</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TrashButton;
